import { RolesEnums } from '@/store/enums/RolesEnums';

const app = {
  path: '/',
  redirect: '/campaigns',
  component: () => import('@/layout/Layout.vue'),
  meta: { roles: [RolesEnums.ALL] },
  children: [
    {
      path: '/campaigns',
      name: 'campaigns',
      meta: { roles: [RolesEnums.ALL] },
      component: () => import('@/views/pages/MyCampaigns.vue')
    }

  ]
};
export default app;
